import { useState, useEffect, useRef } from "react";
import { StripeProvider } from "../../../Stripe/StripeProvider.tsx";
import { FullPageLoading } from "../../../UI/FullPageLoading.tsx";
import { useSearchParams } from "react-router";
import { StripeOrderDTO } from "../../../Stripe/StripeOrderDTO.ts";
import { CardInstallmentsUpdatePaymentForm } from "./CardInstallmentsUpdatePaymentComponents.tsx";
import { useUpdateStripePaymentMethod } from "../../CreateOrderProviders/useUpdateStripePaymentMethod.ts";

function useOrderFromQuery(): {
  orderId: string | undefined;
  itemName: string | undefined;
} {
  const [searchParams] = useSearchParams();

  const orderId = searchParams.get("orderid") ?? undefined;
  const itemName = searchParams.get("itemName") ?? undefined;

  return {
    orderId,
    itemName,
  };
}

export const NormasTeachingCheckoutStripeUpdatePaymentPath =
  "/normasteachingproduct/checkout/update-stripe-payment-method";

export function CardInstallmentsUpdatePaymentStep() {
  const [clientSecret, setClientSecret] = useState<string | null>(null);
  const { updatedOrder, loading } = useUpdateStripePaymentMethod();
  const [orderInfo, setOrderInfo] = useState<{
    normasTeachingItemName: string;
    order: StripeOrderDTO;
    returnUrl?: string;
  } | null>(null);
  const { orderId, itemName } = useOrderFromQuery();

  const orderCreated = useRef(false);

  useEffect(() => {
    if (orderCreated.current) {
      console.log("Order already updated, skipping");
      return;
    }

    console.log("Updating order", orderId);
    const initStripe = async () => {
      orderCreated.current = true;

      try {
        const { order } = await updatedOrder(orderId!);
        console.log("Order updated", order);
        const returnUrl = `${import.meta.env.VITE_STRIPE_ADAPTER_BASE_URL}/payment-return/${order._id}`;
        setClientSecret(order.clientSecret);
        setOrderInfo({
          normasTeachingItemName: itemName!,
          order: order,
          returnUrl: `${returnUrl}`,
        });
      } catch (err) {
        console.error("Error updating order:", err);
        orderCreated.current = false;
        // handleError("Impossibile inizializzare il pagamento.");
      }
    };

    initStripe();
  }, [itemName, orderId, updatedOrder]);

  if (orderId == null) return <p>Order not found</p>;

  if (loading || !clientSecret || !orderInfo) {
    return <FullPageLoading />;
  }

  return (
    <StripeProvider clientSecret={clientSecret}>
      <CardInstallmentsUpdatePaymentForm orderInfo={orderInfo} />
    </StripeProvider>
  );
}
